/**
 * Compare Block.
 * (Used in PDPs)
 */

/**
 * Mobile: Slider with arrow(caret) nav.
 * Desktop: Click on model "btn" highlights btn, displays model content.
 */

let 
	$modelBtns = $('.model-btn'),						// Model buttons. Each button = photo + shadow + excol btn.
	$modelContent = $('.model-content__description'),	// Descriptions.
	$modelBtnsCon = $('.model-btns'),					// Model buttons container.
	$modelContents = $('.model-content'),				// Descriptions container.
	$productContent = $('.product-content'),			// Product content = header + blurb.

	// Mobile models photo slider.
	$myModelPhotosSlider = $('.model-btns'),
    myModelPhotosSliderSettings = {
        adaptiveHeight:false,
		arrows:true,
		appendArrows: $('.model-btns__arrow-nav'),
		asNavFor: '.model-content',
		// centerMode:true,
		// dots: false,
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
		speed:300,
		swipe:false,
        swipeToSlide:false,
		variableWidth:false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
			}
        ]
    },

	// Mobile models text content slider.
	$myModelContentSlider = $('.model-content'),
    myModelContentSliderSettings = {
        adaptiveHeight:true,
		arrows:false,
		// centerMode:true,
		// dots: false,
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
		speed:300,
		swipe:false,
        swipeToSlide:false,
		variableWidth:false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
			}
        ]
    },

	// Models photo slider with multiple tabs/screens, each displaying 2 models.
	// Desktop.
	$myTypesSlider = $('.model-types'),
    myTypesSliderSettings = {
        adaptiveHeight:true,
		arrows:false,
		// centerMode:true,
		dots: true,
		appendDots: $('.model-types__dot-nav'),
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
		speed:300,
		swipe:false,
        swipeToSlide:false,
		variableWidth:false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
			}
        ]
    };

let
	moreThanOneType = false,	// Product has more than one type, displays tabbed pages of models.
	origTypesHtml = '';			// Save original more-than-one-type .model-types HTML.

function initMobileSlider() {
	// console.log('COMPARE: initMobileSlider()');
	
	// If they exist, remove .model-type and .model-btns layer of element before creating slider.
	var $myTypes = $('.model-type');

	if ($myTypes.length) {
		moreThanOneType = true;
		$myTypes.each(function(index) {
			$(this).replaceWith($(this).find('.model-btns').children());
		});
		$myModelPhotosSlider = $('.model-types');
	} else {
		$myModelPhotosSlider = $('.model-btns');
	}
	if ($myModelPhotosSlider.hasClass('slick-initialized')) {
		$myModelPhotosSlider.slick('unslick');
	}

	// console.log('$myModelPhotosSlider: '+$myModelPhotosSlider);
	// console.log('$myModelPhotosSlider: '+$myModelPhotosSlider.attr('class'));

	$myModelPhotosSlider.off('init');	// Disable slick init function for $myTypesSlider set by initDesktopSlider().
	$myModelContentSlider.slick(myModelContentSliderSettings);
	$myModelPhotosSlider.slick(myModelPhotosSliderSettings);


	setTimeout(()=> {
		updateMobileSliderLayout();
	}, 100);
}

function updateMobileSliderLayout() {
	// Update vertical positioning of elements in mobile slider.
	// console.log('COMPARE: updateMobileSliderLayout()');

	// var slider_h = $modelBtnsCon.innerHeight();
	// if (slider_h == 0) {
	// 	slider_h = $('.model-types').innerHeight();
	// }
	// var content_slider_h = $modelContents.innerHeight();
	// var prod_content_h = $productContent.outerHeight(true);
	// var model_contents_y = slider_h + prod_content_h;

	// // Set y-pos/top value to combined height of product content (header + blurb) and model photos slider.
	// $modelContents.css('top', model_contents_y + 'px');
	// // Add container height to absolute model contents
	// $('.compare-block__content-right').css('margin-bottom', (content_slider_h) + 'px' );

	var content_h = $('.product-content').outerHeight(true);
	$('.compare-block__content-right').css('top', content_h+'px');
	var photos_slider_h = $('.model-types').innerHeight() + parseInt($('.product-content').css('margin-bottom'), 10);
	$('.model-content').css('margin-top', (photos_slider_h + 20)+'px');
}

function initDesktopSlider() {
	// console.log('COMPARE: initDesktopSlider()');
	// Run only if more than one model type is defined. (Osprey)
	var $myTypes = $('.model-type');
	if ($myTypes.length) {
		moreThanOneType = true;
	}
	if (!moreThanOneType) {
		return;
	}

	// If .model-type and .model-btns element layers do not exist, restore original HTML.
	if (!$myTypes.length) {
		$('.model-types').html(origTypesHtml);
	}

	// On slider init, apply text from data-label as content for each slick dot nav dot.
	$myTypesSlider.on('init', function(event, slick){
		var $myDots = $( '.slick-dots li' );
		$myDots.each( function( k, v){
		  $(this).find('button').addClass( 'tab label'+ k );
		});
		var $mySlides = slick.$slides;
		// console.log('COMPARE: initDesktopSlider(): $mySlides: '+$mySlides);
		// console.log('COMPARE: initDesktopSlider(): $mySlides: '+$mySlides.attr('class'));
		$mySlides.each( function( k, v){
			var text = $(this).find('.model-type').data('label');
			$( '.tab.label' + k ).text(text);
		});
		setTimeout(()=> {
			initDesktopCompareClicks();	// Moved here from exports.init and initResizeWatcher(), where it *followed* initDesktopSlider().
		}, 100);
	});

	// Init slider.
	$myTypesSlider.slick(myTypesSliderSettings);

	// Update model content height.
	setTimeout(()=> {
		updateDesktopContentLayout();
	}, 100);

	// On tab click, reset/remove .active/.inactive class/states from models.
	// So, if a model is selected, clicking a tab deselects it.
	let 
		$myTabs = $('.model-types__dot-nav .slick-dots button.tab');

	if ($myTabs.length) {
		$myTabs.on('click', function() {
			$modelBtns.removeClass('active');
			$modelBtns.removeClass('inactive');
			$modelContent.removeClass('active');
			$modelContent.removeClass('inactive');
		});
	}
}

function initDesktopCompareClicks() {
	// console.log('COMPARE: initDesktopCompareClicks()');
	// console.log('COMPARE: initDesktopCompareClicks(): $modelBtns: '+$modelBtns);
	// console.log('COMPARE: initDesktopCompareClicks(): $modelBtns: '+$modelBtns.length);
	// console.log('COMPARE: initDesktopCompareClicks(): $modelBtns: '+$modelBtns.attr('class'));

	$modelBtns.off();
	$modelBtns = $('.model-btn');	// FIX! $modelBtns seems to refer to "old"/previous instances and does not reset/include new instances.
	// May see this in the ids of the slider elements changing/updating.

	$modelBtns.on('click', function() {
		// console.log('COMPARE: initDesktopCompareClicks(): CLICK: '+$(this).attr('class'));

		var my_model = $(this).data('model');
		var $myContent = $modelContent.filter('[data-model="'+my_model+'"]');
		var $altModel = $modelBtns.not('[data-model="'+my_model+'"]');
		var $altContent = $modelContent.not('[data-model="'+my_model+'"]');

		if ($(this).hasClass('active')) {
			$modelBtns.removeClass('active');
			$modelBtns.removeClass('inactive');
			$modelContent.removeClass('active');
			$modelContent.removeClass('inactive');
		} else {
			$modelBtns.removeClass('active');
			$modelBtns.removeClass('inactive');
			$(this).addClass('active');
			$modelContent.removeClass('active');
			$modelContent.removeClass('inactive');
			$myContent.addClass('active');
			$altModel.addClass('inactive');
			$altContent.addClass('inactive');
		}
	});
}

function updateDesktopContentLayout() {
	console.log('COMPARE: updateDesktopContentLayout()');
	// Set the height of the model descriptions container to account for the tallest description.
	// (Descriptions are position:absolute.)

	var $myDescriptions = $('.model-content__description');
	var $myDescriptionsCon = $('.model-content');
	var h_array = [];

	$myDescriptions.each(function(index) {
		h_array.push(parseInt($(this).outerHeight()));
	});
	// console.log('COMPARE: updateDesktopContentLayout(): h_array: '+h_array);
	// console.log('COMPARE: updateDesktopContentLayout(): h_array: '+Math.max(...h_array));
	$myDescriptionsCon.css('height', Math.max(...h_array)+'px');
}

let
	$window = $(window),
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	breakpoint = 1024,
	sliderLayoutTimeout = undefined;

function initResizeWatcher() {
	// console.log('COMPARE: initResizeWatcher()');

	$window.on('resize', function() {
		currWindowW = $window.width();

		// Viewport width is mobile (< 1024).
		if (currWindowW < breakpoint) {
			sliderLayoutTimeout = setTimeout(()=> {
				updateMobileSliderLayout();
			}, 100);

			// Unslick and re-slick on resize.
			// $myModelContentSlider.slick('unslick');
			// $myModelPhotosSlider.slick('unslick');
			// initMobileSlider();
		}

		// Viewport width is desktop (>= 1024).
		if (currWindowW >= breakpoint) {
			updateDesktopContentLayout();
		}

		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= breakpoint) && (prevWindowW < breakpoint)) {
			// console.log('TIMEOUT: sliderLayoutTimeout: clearTimeout()');
			// clearTimeout(sliderLayoutTimeout);	// Attempt to restore click functionality to desktop .model-btn.
			// Traces indicated that sliderLayoutTimeout fired after initMobileSlider() and might interfere w .on('click').

			$myTypesSlider.slick('unslick');
			$myModelContentSlider.slick('unslick');
			$myModelPhotosSlider.slick('unslick');
			// $('.model-types').slick('unslick');

			clearTimeout(sliderLayoutTimeout);
			$('.model-content').css('margin-top', '');
			$('.compare-block__content-right').css('top', '');

			initDesktopSlider();
			// initDesktopCompareClicks();
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < breakpoint) && (prevWindowW >= breakpoint)) {
			$modelBtns.removeClass('active');
			$modelBtns.removeClass('inactive');
			$modelContent.removeClass('active');
			$modelContent.removeClass('inactive');

			$('.model-content').css('height', '');

			initMobileSlider();
		}

		prevWindowW = $window.width();
	});
}

exports.init = function () {
	// console.log('COMPARE: exports.init');
    // Run init methods...

	origTypesHtml = $('.model-types').html();

	if ($window.width() < breakpoint) {
		initMobileSlider();
	} else {
		initDesktopSlider();
		// initDesktopCompareClicks();
	}
	initResizeWatcher();
};